// Shared Approve / Reject / Edit-before-approving button row for a PENDING
// or CANDIDATE memory — identical markup/behavior on both the
// /agents/memories list (MemoryListRow) and the PA chat inline card
// (SaveMemoryToolCard), which previously re-implemented this independently.
export function MemoryApprovalButtons({
  size,
  onApprove,
  onReject,
  onEdit,
  disabled,
  rejectClassName,
}: {
  size: 'xs' | 'sm';
  onApprove: () => void;
  onReject: () => void;
  onEdit: () => void;
  disabled: boolean;
  /** Extra class on the Reject button — surfaces style it differently (e.g. a red-tinted hover). */
  rejectClassName?: string;
}) {
  const sizeClass = `btn--${size}`;
  return (
    <>
      <button
        type="button"
        className={`btn btn--primary ${sizeClass}`}
        onClick={onApprove}
        disabled={disabled}
      >
        Approve
      </button>
      <button
        type="button"
        className={`btn btn--ghost ${sizeClass}${rejectClassName ? ` ${rejectClassName}` : ''}`}
        onClick={onReject}
        disabled={disabled}
      >
        Reject
      </button>
      <button
        type="button"
        className={`btn btn--ghost ${sizeClass}`}
        onClick={onEdit}
        disabled={disabled}
      >
        Edit before approving
      </button>
    </>
  );
}
